<template>
  <div />
</template>

<script>
export default {
  name: 'PageInit',
  data: () => {
    return {
      params: {}
    }
  },

  mounted: function() {
    this.params = this.getParams()

    if (this.redirectGeneva())
      return

    this.$store.commit('setLoginAction', this.params.Action)
    this.$store.commit('setRealtorId', this.params.RealtorID || null)
    this.$store.commit('setLoanId', this.params.LoanID)

    this.initCompanyConfiguration()
  },

  methods: {
    getParams: function () {
      var lookup = {}

      var href = window.location.href.replace(/^(#\/)+|(#\/)+$/gm, '')
      var query = href.split('?')

      if (query.length !== 2) return lookup

      var params = query[1].split('&')
      for (var i = 0; i < params.length; i++) {
        var keyVal = params[i].split('=')
        if (keyVal.length !== 2) continue

        keyVal[0] = decodeURIComponent(keyVal[0])
        keyVal[1] = decodeURIComponent(keyVal[1])

        lookup[keyVal[0]] = keyVal[1]
      }

      return lookup
    },
    initCompanyConfiguration: function () {
      var $this = this
      
      Promise.all([
        $this.$store.dispatch('initCompany', $this.params.CompanyID),
        $this.$store.dispatch('initOfficer', { CompanyID: $this.params.CompanyID, UserID: $this.params.OfficerID })
      ])
      .then(r => {
        var company = r[0]

        if (!company) {
          $this.$store.commit('setReady', true)
          $this.$store.dispatch('go', 'error')
        }
        else {
          $this.$store.dispatch('initLocalization')
          $this.initSession()
        }
      })
    },
    initSession: function () {
      var $this = this

      $this.initSessionFromCode()
        .then(() => { return $this.initSessionFromStorage() })
          .then(() => { return $this.$store.dispatch('initForSession') })
    },
    initSessionFromCode() {
      var $this = this

      return new Promise((resolve, reject) => {
        if ($this.$store.getters.getSessionToken)
          resolve()

        $this.$store.dispatch('loginWithAccessCode', $this.params.AccessCode).then(() => { resolve() })
      })
    },
    initSessionFromStorage() {
      var $this = this

      return new Promise((resolve, reject) => {
        if ($this.$store.getters.getSessionToken)
          resolve()

        $this.$store.dispatch('loginWithStoredCredentials').then(() => { resolve() })
      })
    },
    redirectGeneva: function () {
      if ([1897, 2239, 2411, 2428, 2591, 2592, 2593, 2594, 2595, 2596, 2597, 2598, 2599, 2600, 2601, 2602, 2603, 2604, 2605, 2606, 2607, 2608, 2609, 2610, 2611, 2612, 2613, 2614, 2615, 2616, 2617, 2618, 2619, 2620, 2621, 2622, 2623, 2624, 2625, 2626, 2627, 2628, 2629, 2630, 2631, 2632, 2633, 2635, 2636, 2639, 2645, 2660, 2661, 2668, 2671, 2672, 2673, 2685, 2689, 2693, 2694, 2699, 2705, 2706, 2707, 2715, 2718, 2732, 2741, 2744, 2748, 2753, 2840, 2890, 2904, 2929, 2992, 3035, 3049, 3050, 3068, 3071, 3291, 3338, 3360, 3449, 3576, 3625, 3752, 3753, 3755, 3763, 3802, 3881, 3882, 3940, 4003, 4076, 4138, 4139, 4141, 4153, 4158, 4169, 4187, 4225, 4237, 4248, 4261, 4296, 4304, 4317, 4320, 4342, 4344, 4350, 4371, 4383, 4402, 4450, 4454, 4461, 4475, 4502, 4514, 4515, 4536, 4552, 4555, 4587, 4592, 4599, 4610, 4631, 4662, 4667, 4670, 4673, 4676, 4685, 4688, 4731, 4741, 4816, 4847, 4851, 4854, 4855, 4881, 4882, 4889, 4894, 4913, 4923, 4927, 4950, 4956, 4957, 5005, 5024, 5060, 5081, 5098, 5109, 5110, 5114, 5126, 5148, 5149, 5181, 5183, 5184, 5194, 5205, 5207, 5213, 5228, 5251, 5475, 5714, 5715, 3124, 3179, 3624, 4341, 4930, 5176, 5185, 5189, 5200, 5303, 5384, 5474, 4671, 4672, 3848, 3036, 4297, 4147, 4233, 2738, 4655, 2739, 2740, 2742, 2743, 2745, 2746, 2747, 2749, 2750, 2751, 2954, 3084, 3187, 3614, 3618, 3851, 4188, 5293, 5422, 5832, 5044, 5839, 2752, 2993, 4558, 4616, 1545, 2731, 2733, 2734, 2735, 2736, 2737, 2926, 2931, 2932, 3200, 3719, 3847, 4214, 4556, 4605, 4890, 4922, 5153, 5212, 5365, 5419, 5425, 5470, 5577, 5688, 2730, 2906, 3359, 4546, 2728, 2729, 2727, 3337, 3426, 3501, 5841, 2726, 2725, 2717, 2719, 2720, 2721, 2722, 2723, 2724, 3292, 5255, 4001, 2716, 3883, 5347, 2714, 2927, 3015, 3285, 3792, 3816, 5260, 5262, 5375, 2711, 2712, 2713, 3102, 3623, 5121, 2710, 5860, 2709, 3086, 3172, 4507, 4629, 5711, 5893, 2708, 3063, 4775, 3658, 3850, 4358, 4630, 5214, 5283, 5461, 5521, 5938, 2703, 2704, 2700, 2701, 2702, 2697, 2698, 2928, 3939, 2696, 5118, 2695, 3466, 5232, 3756, 2691, 2692, 3355, 3905, 2690, 4289, 5477, 5267, 5322, 5373, 5831, 2688, 5250, 5486, 2687, 5780, 2686, 5410, 4984, 2683, 2684, 4213, 5285, 5919, 2679, 2680, 2681, 2682, 2677, 2678, 2674, 2675, 2676, 2995, 3087, 3093, 4640, 4849, 5462, 5480, 5493, 2669, 2670, 3085, 3387, 3746, 4093, 4318, 4476, 4701, 4790, 4798, 4839, 5282, 5754, 2665, 2666, 2667, 2664, 2662, 2663, 2940, 3613, 4203, 4373, 5234, 5483, 2651, 2652, 2653, 2654, 2655, 2656, 2657, 2658, 2659, 2933, 3083, 3140, 3305, 3357, 3542, 3578, 3803, 4085, 4196, 4659, 4908, 5000, 5415, 2650, 3123, 3747, 4305, 4722, 5043, 2634, 2637, 2638, 2640, 2641, 2642, 2643, 2644, 2646, 2647, 2648, 2649, 3082, 3660, 3694, 3825, 4002, 4155, 4280, 4328, 4447, 4467, 4528, 4660, 4774, 4974, 5091, 5332, 5757, 5883, 5912].indexOf(this.params.CompanyID * 1) !== -1)
        if ((this.params.OfficerID * 1) != 268591) {
          window.location = 'https://www.genevafi.com/apply-now/'
          return true
        }

      return false
    }
  }
}
</script>